module.exports = __webpack_public_path__ + "img/miles-alert.6f08fe96.png";